<template>
  <div>
    <Filtration
      :readonly="true"
      :filtration="datas.filtration"
    />
    <System
      :readonly="true"
      :system="datas.system"
    />
    <Treatment
      :readonly="true"
      :siteId="mutableValue.analysisRequest.site.id"
      :treatment="datas.treatment"
    />
  </div>
</template>
<script>
import Filtration from '@/components/forms/technicalFile/closedLoop/forms/Filtration.vue';
import System from '@/components/forms/technicalFile/closedLoop/forms/System.vue';
import Treatment from '@/components/forms/technicalFile/closedLoop/forms/Treatment.vue';

export default {
    name: 'TechnicalFileClosedLoop',
    components: { Filtration, System, Treatment },
    props: {
        mutableValue: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            datas: { },
        };
    },

    async mounted() {
        const myDatas = await this.initDataFromBackend();
        this.datas = myDatas.data;
    },

    methods: {
        async initDataFromBackend() {
            const { data } = await this.$rq.getNodeInfo(this.mutableValue.analysisRequest.site.id,
                this.mutableValue.analysisRequest.component.id, { closedLoopChild: true });
            return {
                data,
            };
        },
    },
};


</script>
